/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from "prop-types";
import { forwardRef } from "react";
// import dynamic from "next/dynamic";

import Simple from "./Simple";
import Preview from "./Preview";
import Vertical from "./Vertical";
// import NormalSlider from "./Normal";
import Normal from "./Normal";
// const Simple = dynamic(() => import("./Simple"));
// const Preview = dynamic(() => import("./Preview"));
// const Vertical = dynamic(() => import("./Vertical"));
// const Normal = dynamic(() => import("./Normal"));

/**
 *
 * @param {{
 * type: "simple"|"normal"|"preview"|"vertical";
 * }} props Props for the component
 *
 */

const Slider = forwardRef(function Slider({ children, type, ...props }, ref) {
  const renderSlider = () => {
    switch (type) {
      case "normal":
        return (
          <Normal ref={ref} {...props}>
            {children}
          </Normal>
        );
      case "vertical":
        return (
          <Vertical ref={ref} {...props}>
            {children}
          </Vertical>
        );
      case "preview":
        return (
          <Preview ref={ref} {...props}>
            {children}
          </Preview>
        );
      case "simple":
      default:
        return (
          <Simple ref={ref} {...props}>
            {children}
          </Simple>
        );
    }
  };

  return <>{renderSlider()}</>;
});

Slider.propTypes = {
  type: PropTypes.string,
};

Slider.defaultProps = {
  type: "",
};

export default Slider;
